import { NgClass, NgIf } from '@angular/common';
import {
  ChangeDetectorRef,
  Component, ComponentRef,
  EnvironmentInjector, EventEmitter, Input, OnInit, Output, Type, ViewChild, ViewContainerRef, inject, runInInjectionContext
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { OrderService } from '../../_service/OrderService';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { takeUntil } from 'rxjs';

@Component({
    selector: 'app-overlay',
    templateUrl: './overlay.component.html',
    styleUrls: ['overlay.component.scss'],
    standalone: true,
  imports: [
    NgClass,
    TranslateModule
  ]
})
export class OverlayComponent implements OnInit{

  private _innerComponent: Type<any>
  @Input() set innerComponent(value: Type<any>) {
    this._innerComponent = value;
  }

  @Input() showClose: boolean = true;

  //to be able to overrule the rounded and bg properties
  private _elementClass:string = "";
  @Input() set elementClass (value: string){
    this._elementClass = value;
    this.setDefaultClasses()
  }
  get elementClass(){
    this.setDefaultClasses()
    return this._elementClass
  }

  setDefaultClasses(){
    if(!this._elementClass.includes('rounded-'))
      this._elementClass += ' rounded-lg'
    if(!this._elementClass.includes('bg-'))
      this._elementClass += ' bg-white'
  }

  @Output() createdComponent: EventEmitter<any> = new EventEmitter<any>()


  //to make sure it is always closed
  private _modal: NgbModalRef
  set modal(value: NgbModalRef){
    this._modal = value;
    this._modal.dismissed.pipe(takeUntil( this._modal.closed)).subscribe(()=>{
      this._modal.close()
    })
  }
  get modal(){
    return this._modal
  }

  componentRef: ComponentRef<Component>;
  @ViewChild('dynamicContent', { read: ViewContainerRef }) private dynamicContentContainer!: ViewContainerRef;


  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private injector: EnvironmentInjector,
  )
  { }


  ngOnInit() {

  }

  public ngAfterViewChecked() {
    if (
      this.dynamicContentContainer
      && this.dynamicContentContainer.length === 0
      && this._innerComponent
    ) {
      this.createComponent(this._innerComponent);
    }
  }

  public markForCheck() {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) { /* empty */ }

    this._changeDetectorRef.markForCheck();
  }

  createComponent(component: Type<any>) {
    this.dynamicContentContainer.clear();
    if (component) {
      //let envInjector = null;
      runInInjectionContext(this.injector, () => {
        //const _HttpClient = inject(HttpClient)
        const _orderService = inject(OrderService) // injection possible thanks to the injection context provided by the environment injector
        
      })

      this.componentRef = this.dynamicContentContainer.createComponent(component, { injector: this.injector, environmentInjector: this.injector });
    }
    this.markForCheck();

    this.createdComponent.emit(this.componentRef.instance);
  }

  closeOverlay() {
    // if(this.dialogRef && typeof this.dialogRef.close === 'function'){
    //   this.dialogRef.close();
    // }else 
    if(this.modal){
      this.modal.close();
    }
  }




}
